export const SPRAY_SUBMISSION_VIEW_PAYLOAD_MODAL =
    'spraySubmissionViewPayloadModal';
